import { Banner, Btn, Card, H, P, useInnspel, useOffline } from '../../lib/index.ts';
import type { PortalKonfig } from '../konfig.ts';

/**
 * 1 — landing (portal.jsx). To store handlinger: «Send innspill» går rett i
 * flyten, anonymt når hun ikke er innlogget; «Logg inn hos <leietaker>» er
 * redirecten. Forklaringen sier hva som skjer (DD-05-ånd). Offline (DD-41):
 * innlogging krever nett, tekst kan køes.
 */
export function Landing({ konfig, innlogget, onLoggInn }: { konfig: PortalKonfig; innlogget: boolean; onLoggInn: () => void }) {
  const { open } = useInnspel();
  const offline = useOffline();

  return (
    <>
      <H nivaa={1} sub={`Feil og ønsker til ${konfig.tenantName}. Du får svar — også hvis det er nei.`}>{`Send innspill til ${konfig.tenantName}`}</H>
      {offline ? (
        <Banner ikon="cloud-offline-outline" tone="info" live>
          Ingen nett. Du kan skrive og lagre — det sendes automatisk når du er på nett. Innlogging hos {konfig.tenantName} venter til da.
        </Banner>
      ) : null}
      <Btn
        tall
        ikon="chatbubble-outline"
        testId="send-innspill"
        label={offline ? 'Skriv innspill — sendes når du er på nett' : 'Send innspill'}
        hint={innlogget ? undefined : 'Uten innlogging — du får ikke svar, men det teller.'}
        onClick={() => void open()}
      />
      {!innlogget && konfig.loginRedirectUrl ? (
        <Btn tall variant="secondary" ikon="key-outline" testId="logg-inn-hos" label={`Logg inn hos ${konfig.tenantName} for å følge saken din`} disabled={offline} hint={offline ? 'Krever nett.' : undefined} onClick={onLoggInn} />
      ) : null}
      {!innlogget ? (
        <Card dashed>
          <P>Du logger inn hos {konfig.tenantName}, ikke her. Vi får aldri navnet eller e-posten din.</P>
          {/* Grunnen til å logge inn er det hun avgjør på (DD-67 på web) — ikke meta. */}
          <p className="innspel-hjelp">
            Innloggingen gjør at du kan se «Mine innspill» og få svar. {konfig.tenantName} vet hvem du er — vi gjør det ikke.
          </p>
        </Card>
      ) : null}
    </>
  );
}

